import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Utils } from '../../../Utils';
import { Helpers } from '../../../Helpers';
import ReactEcharts from "echarts-for-react";
import ReactECharts from "echarts-for-react";
import { ResponsiveRadialBar } from '@nivo/radial-bar';

// const DialGaugeChart = ({ data = {}, isStatic = false }) => {
//     let getOptions = (valueNumber = 10000) => {
//         valueNumber = Number(valueNumber);
//         let targetNumber = isStatic ? 240 : Number(data?.target);
//         return {
//             tooltip: {
//                 trigger: 'item'
//             },
//             series: [
//                 {
//                     type: 'gauge',
//                     center: ['50%', '60%'],
//                     startAngle: 180,
//                     endAngle: 0,
//                     min: 0,
//                     max: targetNumber,
//                     splitNumber: targetNumber,
//                     progress: {
//                         show: true,
//                         width: 30
//                     },
//                     axisLine: {
//                         lineStyle: {
//                             width: 30
//                         }
//                     },
//                     splitLine: {
//                         show: false
//                     },
//                     axisTick: {
//                         show: false
//                     },
//                     axisLabel: {
//                         distance: -40,
//                         color: '#000',
//                         fontSize: 14,
//                         formatter: (value) => {
//                             if (value === valueNumber) return valueNumber;
//                             return '';
//                         },
//                     },
//                     detail: {
//                         offsetCenter: [0, '30%'],
//                         formatter: (value) => `Remaining: ${targetNumber - value}`,
//                         fontSize: 16,
//                         color: '#333'
//                     },
//                     data: [
//                         {
//                             value: valueNumber
//                         }
//                     ]
//                 }
//             ]
//         }
//     }
//     let [gaugeChartOptions, setGaugeChartOptions] = useState(getOptions());
//     let subModuleData = useSelector((state) => state?.dashboardComponents?.subModuleData);
//     let [width, setWidth] = useState("0%");

//     useEffect(() => {
//         if (subModuleData?.[data?.moduleId]?.length > 0 && Object?.keys(data)?.length > 0 && !isStatic) {
//             let datas = Utils.getFilteredRecords(subModuleData?.[data?.moduleId], data?.duration1, data?.duration2);
//             let newFilteredData = Utils.filteredDataGet(datas, data);
//             let field = data?.field;
//             let calculate = (operation, label) => {
//                 let values = newFilteredData?.map(record => {
//                     let value = 0;
//                     for (let section of record?.data || []) {
//                         if (section?.section_data?.[label] !== undefined) {
//                             value = parseFloat(section.section_data[label]) || 0;
//                             break;
//                         }
//                     }
//                     return value;
//                 });
//                 switch (operation) {
//                     case 'sum':
//                         return values.length ? values.reduce((total, val) => total + val, 0) : 0;
//                     case 'min':
//                         return values.length ? Math.min(...values) : 0;
//                     case 'max':
//                         return values.length ? Math.max(...values) : 0;
//                     case 'average':
//                         return values.length ? values.reduce((total, val) => total + val, 0) / values.length : 0;
//                     default:
//                         return 0;
//                 }
//             };

//             let getLabel = (prefix) => Helpers.replaceData(field?.replace(new RegExp(`^${prefix} of `), ''));

//             if (field?.startsWith("Count of - ")) {
//                 setGaugeChartOptions(getOptions(newFilteredData?.length || 0));
//             } else if (field?.startsWith("Sum of ")) {
//                 let label = getLabel("Sum");
//                 setGaugeChartOptions(getOptions(calculate('sum', label)));
//             } else if (field?.startsWith("Minimum of ")) {
//                 let label = getLabel("Minimum");
//                 setGaugeChartOptions(getOptions(calculate('min', label)));
//             } else if (field?.startsWith("Maximum of ")) {
//                 let label = getLabel("Maximum");
//                 setGaugeChartOptions(getOptions(calculate('max', label)));
//             } else if (field?.startsWith("Average of ")) {
//                 let label = getLabel("Average");
//                 setGaugeChartOptions(getOptions(calculate('average', label)));
//             }
//             setTimeout(() => {
//                 setWidth("100%");
//             }, 100);
//         } else if (isStatic) {
//             setTimeout(() => {
//                 setWidth("100%");
//             }, 100);
//         }
//     }, [subModuleData?.[data?.moduleId], data]);

//     return (
//         <ReactEcharts option={gaugeChartOptions} style={{ height: "100%", width: width }} />
//     );
// }

const DialGaugeChart = ({ data = {}, isStatic = false, target }) => {

    // let getOptions = (valueNumber = 10000) => {
    //     valueNumber = Number(valueNumber);
    //     // let targetNumber = isStatic ? 240 : Number(data?.target);
    //     let targetNumber = data.target ? data?.target : target ? target : 240;
    //     console.log('targetNumber--->', targetNumber);
    //     console.log('value number--->', valueNumber);
    //     return {
    //         series: [
    //             {
    //                 type: 'gauge',
    //                 startAngle: 180,
    //                 endAngle: 0,
    //                 min: 0,
    //                 max: targetNumber,
    //                 splitNumber: targetNumber,
    //                 itemStyle: {
    //                     color: '#58D9F9',
    //                     shadowColor: 'rgba(0,138,255,0.45)',
    //                     shadowBlur: 10,
    //                     shadowOffsetX: 2,
    //                     shadowOffsetY: 2
    //                 },
    //                 progress: {
    //                     show: true,
    //                     roundCap: true,
    //                     width: 30
    //                 },
    //                 pointer: {
    //                     icon: 'path://M2090.36389,615.30999 L2090.36389,615.30999 C2091.48372,615.30999 2092.40383,616.194028 2092.44859,617.312956 L2096.90698,728.755929 C2097.05155,732.369577 2094.2393,735.416212 2090.62566,735.56078 C2090.53845,735.564269 2090.45117,735.566014 2090.36389,735.566014 L2090.36389,735.566014 C2086.74736,735.566014 2083.81557,732.63423 2083.81557,729.017692 C2083.81557,728.930412 2083.81732,728.84314 2083.82081,728.755929 L2088.2792,617.312956 C2088.32396,616.194028 2089.24407,615.30999 2090.36389,615.30999 Z',
    //                     length: '75%',
    //                     width: 16,
    //                     offsetCenter: [0, '5%']
    //                 },
    //                 axisLine: {
    //                     roundCap: true,
    //                     lineStyle: {
    //                         width: 30
    //                     }
    //                 },
    //                 axisTick: {
    //                     show: false
    //                     // splitNumber: 2,
    //                     // lineStyle: {
    //                     //     width: 2,
    //                     //     color: '#999'
    //                     // }
    //                 },
    //                 splitLine: {
    //                     show: false
    //                     // length: 12,
    //                     // lineStyle: {
    //                     //     width: 3,
    //                     //     color: '#999'
    //                     // }
    //                 },
    //                 axisLabel: {
    //                     distance: -40,
    //                     color: '#999',
    //                     fontSize: 20,
    //                     formatter: (value) => {
    //                         if (value === valueNumber) return valueNumber;
    //                         return '';
    //                     },
    //                 },
    //                 // title: {
    //                 //     show: false
    //                 // },
    //                 detail: {
    //                     backgroundColor: '#fff',
    //                     // borderColor: '#999',
    //                     // borderWidth: 2,
    //                     width: '60%',
    //                     lineHeight: 40,
    //                     height: 40,
    //                     borderRadius: 8,
    //                     offsetCenter: [0, '30%'],
    //                     valueAnimation: true,
    //                     formatter: (value) => `Remaining: ${(targetNumber && targetNumber > 0) ? (targetNumber - value) : 'No target'}`,
    //                     // formatter: function (value) {
    //                     //     return '{value|' + value.toFixed(0) + '}{unit|km/h}';
    //                     // },
    //                     rich: {
    //                         value: {
    //                             fontSize: 50,
    //                             fontWeight: 'bolder',
    //                             color: '#777'
    //                         },
    //                         unit: {
    //                             fontSize: 20,
    //                             color: '#999',
    //                             padding: [0, 0, -20, 10]
    //                         }
    //                     }
    //                 },
    //                 data: [
    //                     {
    //                         // value: valueNumber
    //                         value: 0
    //                     }
    //                 ]
    //             }
    //         ]
    //     }
    // };
    // let [_data, set_Data] = useState([
    //     {
    //         id: "meter",
    //         data: [],
    //     }
    // ])

    let value = 100; let max = 100;

    const remaining = Math.max(max - value, 0);

    let _data = [
        {
            id: "meter",
            data: [
                { x: "Used", y: value },
                { x: "Remaining", y: remaining },
            ],
        },
    ];

    let getOptions = (valueNumber = 10000) => {
        valueNumber = Number(valueNumber);

        // 🧠 Get target value safely
        let targetNumber =
            data?.target && data?.target !== "No Target Set"
                ? Number(data?.target)
                : target
                    ? Number(target)
                    : 0;

        // ✅ If targetNumber is 0 or invalid, fix it so gauge renders properly
        const safeMax = targetNumber > 0 ? targetNumber : 100; // fallback gauge max
        const safeValue = targetNumber > 0 ? valueNumber : 0; // pointer at 0 when no target

        const remaining = Math.max(safeMax - safeValue, 0);
        const newDataArray = [
            { x: "Used", y: safeValue },
            { x: "Remaining", y: remaining },
        ];

        _data = [
            {
                id: "meter",
                data: newDataArray
            },
        ]

        // set_Data(prev =>
        //     prev.map(item =>
        //         item.id === "meter"
        //             ? { ...item, data: newDataArray }
        //             : item
        //     )
        // );

        return {
            series: [
                {
                    type: "gauge",
                    startAngle: 180,
                    endAngle: 0,
                    min: 0,
                    max: safeMax, // ✅ always positive
                    splitNumber: safeMax,
                    itemStyle: {
                        color: "#58D9F9",
                        shadowColor: "rgba(0,138,255,0.45)",
                        shadowBlur: 10,
                        shadowOffsetX: 2,
                        shadowOffsetY: 2,
                    },
                    progress: {
                        show: true,
                        roundCap: true,
                        width: 30,
                    },
                    pointer: {
                        icon: "path://M2090.36389,615.30999 L2090.36389,615.30999 C2091.48372,615.30999 2092.40383,616.194028 2092.44859,617.312956 L2096.90698,728.755929 C2097.05155,732.369577 2094.2393,735.416212 2090.62566,735.56078 C2090.53845,735.564269 2090.45117,735.566014 2090.36389,735.566014 L2090.36389,735.566014 C2086.74736,735.566014 2083.81557,732.63423 2083.81557,729.017692 C2083.81557,728.930412 2083.81732,728.84314 2083.82081,728.755929 L2088.2792,617.312956 C2088.32396,616.194028 2089.24407,615.30999 2090.36389,615.30999 Z",
                        length: "75%",
                        width: 16,
                        offsetCenter: [0, "5%"],
                    },
                    axisLine: {
                        roundCap: true,
                        lineStyle: {
                            width: 30,
                        },
                    },
                    axisTick: {
                        show: false,
                    },
                    splitLine: {
                        show: false,
                    },
                    axisLabel: {
                        distance: -40,
                        color: "#999",
                        fontSize: 20,
                        formatter: (value) => {
                            if (value === valueNumber) return valueNumber;
                            return "";
                        },
                    },
                    detail: {
                        backgroundColor: "#fff",
                        width: "60%",
                        lineHeight: 40,
                        height: 40,
                        borderRadius: 8,
                        offsetCenter: [0, "30%"],
                        valueAnimation: true,
                        formatter: (value) =>
                            targetNumber > 0
                                ? `Remaining: ${targetNumber - value}`
                                : "No target",
                        rich: {
                            value: {
                                fontSize: 50,
                                fontWeight: "bolder",
                                color: "#777",
                            },
                            unit: {
                                fontSize: 20,
                                color: "#999",
                                padding: [0, 0, -20, 10],
                            },
                        },
                    },
                    data: [
                        {
                            value: safeValue, // ✅ shows 0 if no target
                        },
                    ],
                },
            ],
        };
    };

    let [gaugeChartOptions, setGaugeChartOptions] = useState(getOptions());
    let subModuleData = useSelector((state) => state?.dashboardComponents?.subModuleData);
    let [width, setWidth] = useState("0%");

    useEffect(() => {
        // debugger
        // console.log('DATA---->', data)
        if (subModuleData?.[data?.moduleId]?.length > 0 && Object?.keys(data)?.length > 0 && !isStatic) {
            let datas = Utils.getFilteredRecords(subModuleData?.[data?.moduleId], data?.duration1, data?.duration2);
            let newFilteredData = Utils.filteredDataGet(datas, data);
            let field = data?.field;
            let calculate = (operation, label) => {
                let values = newFilteredData?.map(record => {
                    let value = 0;
                    for (let section of record?.data || []) {
                        if (section?.section_data?.[label] !== undefined) {
                            value = parseFloat(section.section_data[label]) || 0;
                            break;
                        }
                    }
                    return value;
                });
                switch (operation) {
                    case 'sum':
                        return values.length ? values.reduce((total, val) => total + val, 0) : 0;
                    case 'min':
                        return values.length ? Math.min(...values) : 0;
                    case 'max':
                        return values.length ? Math.max(...values) : 0;
                    case 'average':
                        return values.length ? values.reduce((total, val) => total + val, 0) / values.length : 0;
                    default:
                        return 0;
                }
            };

            let getLabel = (prefix) => Helpers.replaceData(field?.replace(new RegExp(`^${prefix} of `), ''));
            // debugger
            if (field?.startsWith("Count of - ")) {
                setGaugeChartOptions(getOptions(newFilteredData?.length || 0));
            } else if (field?.startsWith("Sum of ")) {
                let label = getLabel("Sum");
                setGaugeChartOptions(getOptions(calculate('sum', label)));
            } else if (field?.startsWith("Minimum of ")) {
                let label = getLabel("Minimum");
                setGaugeChartOptions(getOptions(calculate('min', label)));
            } else if (field?.startsWith("Maximum of ")) {
                let label = getLabel("Maximum");
                setGaugeChartOptions(getOptions(calculate('max', label)));
            } else if (field?.startsWith("Average of ")) {
                let label = getLabel("Average");
                setGaugeChartOptions(getOptions(calculate('average', label)));
            }
            setTimeout(() => {
                setWidth("100%");
            }, 100);
        } else if (isStatic) {
            setTimeout(() => {
                setWidth("100%");
            }, 100);
        }
    }, [subModuleData?.[data?.moduleId], data]);

    // let value = 100; let max = 100;

    // const remaining = Math.max(max - value, 0);

    // // const _data = [
    // //     {
    // //         id: "meter",
    // //         data: [
    // //             { x: "Used", y: value },
    // //             { x: "Remaining", y: remaining },
    // //         ],
    // //     },
    // // ];
    console.log('gaugeChartOptions--->', gaugeChartOptions);
    return (
        // <div style={{ width: "100%", height: "100%" }}>
        <div style={{
            width: "100%",
            height: "100%",
            minWidth: "245px",
            minHeight: "300px"
        }}>
            {/* <ReactECharts option={gaugeChartOptions} style={{ height: "100%" }} /> */}
            <div style={{ height: 300 }}>
                <ResponsiveRadialBar
                    data={_data}

                    valueFormat=">-.2f"
                    padding={0.4}
                    // cornerRadius={2}
                    margin={{ top: 40, right: 120, bottom: 40, left: 40 }}
                    radialAxisStart={{ tickSize: 5, tickPadding: 5, tickRotation: 0 }}
                    circularAxisOuter={{ tickSize: 5, tickPadding: 12, tickRotation: 0 }}
                    legends={[
                        {
                            anchor: 'right',
                            direction: 'column',
                            translateX: 80,
                            itemsSpacing: 6,
                            itemWidth: 100,
                            itemHeight: 18
                        }
                    ]}

                    startAngle={-90}
                    endAngle={90}
                    innerRadius={0.75}
                    padAngle={0.4}
                    cornerRadius={8}
                    // colors={["#2563eb", "#e5e7eb"]}
                    // radialAxisStart={null}
                    // radialAxisEnd={null}
                    // circularAxisOuter={null}
                    // enableTracks={false}


                    /* ⭐ CENTER TEXT */
                    layers={[
                        "bars",
                        ({ center }) => (
                            <g transform={`translate(${center[0]}, ${center[1]})`}>
                                <text
                                    textAnchor="middle"
                                    dominantBaseline="central"
                                    style={{
                                        fontSize: 22,
                                        fontWeight: 700,
                                        fill: "#111827",
                                    }}
                                >
                                    {remaining}%
                                </text>

                                <text
                                    y={26}
                                    textAnchor="middle"
                                    style={{
                                        fontSize: 12,
                                        fill: "#6b7280",
                                    }}
                                >
                                    Remaining
                                </text>
                            </g>
                        ),
                    ]}

                    tooltip={({ bar }) => (
                        <strong>
                            {bar.data.x}: {bar.value}
                        </strong>
                    )}
                />
            </div>
        </div>
    );
}

export default DialGaugeChart;

